<template>
  <div></div>
</template>

<script>
export default {
  path: 'ssm',
  privCode: 'ssm3',
  displayNameKey: 'ssm',
  name: 'ssm',
  isLink: true,
};
</script>



// WEBPACK FOOTER //
// src/modules/SSM/SSM.vue